export default __webpack_public_path__ + "static/article-why-millennials-are-becoming-the-most-financial-savvy-generation-2aa1a32d817a052a8aedab7beb855dbf.jpg";